import { ServiceClient } from '@johnlewispartnership/wtr-website-api-client';
import config from 'config';
import getApiBaseUrl from 'utils/getApiBaseUrl';
import { logApiError, logApiInfo } from 'logger';
import { DELIVERY_PASS_NOT_AVAILABLE } from 'constants/delivery-pass-statuses';
import { GetDeliveryPassServiceResponseData, GetDeliveryPassServiceResult } from './types';

const deliveryPassApiUrl = getApiBaseUrl(config.services.deliveryPass.path);

class DeliveryPassServiceClient extends ServiceClient {
  async getDeliveryPassStatus({
    authHeader,
    customerId,
  }: {
    authHeader: string;
    customerId: string;
  }): Promise<GetDeliveryPassServiceResult> {
    const response = await this.httpClient.get<GetDeliveryPassServiceResponseData>(
      'v1/pass/status',
      {
        headers: {
          Authorization: authHeader,
          breadcrumb: config.applicationName,
          'customer-id': customerId,
        },
      },
    );

    const status = response?.data?.status;

    if (!response?.error) {
      logApiInfo({
        payload: {
          duration: response.duration,
          service: 'deliveryPass',
          url: deliveryPassApiUrl,
          message: `Delivery pass status loaded from server, request took ${response.duration}ms`,
          httpStatus: String(response.status),
          httpStatusCode: response.status,
        },
      });
    } else {
      logApiError({
        payload: {
          duration: response.duration,
          service: 'deliveryPass',
          url: deliveryPassApiUrl,
          message: `Error loading delivery pass status: ${response.error.message}`,
          httpStatus: String(response.status),
          httpStatusCode: response.status,
        },
      });
    }

    return {
      status: status || DELIVERY_PASS_NOT_AVAILABLE,
    };
  }
}

const deliveryPassServiceClient = new DeliveryPassServiceClient(deliveryPassApiUrl);

export default deliveryPassServiceClient;
